// extracted by mini-css-extract-plugin
export var divider = "_fe-7";
export var itemsToggle = "_fe-8";
export var mergeModal = "_fe-1";
export var optionCard = "_fe-4";
export var radioGroup = "_fe-6";
export var radioOption = "_fe-0";
export var selected = "_fe-5";
export var shipmentOptions = "_fe-2";
export var tableOptions = "_fe-3";